// components/TuneCardBox.js
import React from 'react';

export default function TuneCardBox({ children, onClick, style = {} }) {
  return (
    <li
      className="card"
      onClick={onClick}
      style={{
        backgroundColor: 'var(--bg-card)',
        color: 'var(--text-primary)',
        border: '1px solid var(--card-border)',
        borderRadius: '8px',
        padding: '1rem',
        marginBottom: '10px',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      {children}
    </li>
  );
}
